__turbopack_context__.v({
  "actions": "FeeSlider-module__S2FuFq__actions",
  "feeSlider": "FeeSlider-module__S2FuFq__feeSlider",
  "header": "FeeSlider-module__S2FuFq__header",
  "input": "FeeSlider-module__S2FuFq__input",
  "inputEndAdornment": "FeeSlider-module__S2FuFq__inputEndAdornment",
  "inputEndAdornmentLabel": "FeeSlider-module__S2FuFq__inputEndAdornmentLabel",
  "inputRoot": "FeeSlider-module__S2FuFq__inputRoot",
  "medium": "FeeSlider-module__S2FuFq__medium",
  "network": "FeeSlider-module__S2FuFq__network",
  "root": "FeeSlider-module__S2FuFq__root",
  "slider": "FeeSlider-module__S2FuFq__slider",
  "slow": "FeeSlider-module__S2FuFq__slow",
  "stats": "FeeSlider-module__S2FuFq__stats",
});
